import imageCompression from "browser-image-compression";
import { useEffect, useRef } from "react";
import ReactQuill from "react-quill";
import { uploadToFirebaseStorage } from "../../../lib/firebase";
import { COMPRESSION_OPTION } from "../../../utilities/constants";

function useEditor(mediaFolder: string = "content") {
  const editorRef = useRef<ReactQuill>(null);

  useEffect(() => {
    /**
     * When user upload an image from quill editor
     * It gets file from html input
     * and upload it to firebase storage
     * and get the url for the image
     */
    function imageUploader() {
      const input = document.createElement("input");

      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/*");
      input.click();

      input.onchange = async () => {
        const file = input.files![0];

        const compressedFile = await imageCompression(file, COMPRESSION_OPTION);
        const { name, size, type } = compressedFile;

        const metadata = { name, size, type };
        const url = await uploadToFirebaseStorage(
          compressedFile,
          metadata,
          mediaFolder
        );

        if (url && editorRef?.current) {
          const range = editorRef?.current?.getEditor().getSelection();

          editorRef?.current
            ?.getEditor()
            .insertEmbed(range?.index!, "image", url);
        }
      };
    }

    if (editorRef?.current) {
      const toolbar = editorRef?.current.getEditor().getModule("toolbar");
      toolbar.addHandler("image", imageUploader);
    }
  }, [mediaFolder]);

  useEffect(() => {
    if (editorRef.current) {
      const editor = editorRef.current.getEditor();

      // Set the default selection in the toolbar dropdown
      const toolbar = editor.getModule("toolbar");
      toolbar.container.querySelector(".ql-size").value = "14px"; // Set to the first allowed value

      editor.format("size", "14px"); // Apply it to the editor content
    }
  }, [editorRef]);

  return {
    refs: {
      editorRef,
    },
  };
}

export default useEditor;
